import * as S from './styles';

export type SidebarBoxTypes = {
  children: React.ReactNode;
  as?: React.ElementType;
  variant?: 'primary' | 'secondary' | 'third';
};

const SidebarBox = ({ children, as, variant = 'primary', ref }: SidebarBoxTypes & { ref?: React.Ref<any> }) => (
  <S.Wrapper variant={variant} as={as} ref={ref}>
    {children}
  </S.Wrapper>
);

export default SidebarBox;
